import axios from 'axios'
import API_URL from '@/router/api'
import jwtDecode from 'jwt-decode'
import * as types from './mutation-types'
import UserService from '@/service/user'


export const login = (ctx, form) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.login, form)
            .then(res => {
                const encodeToken = jwtDecode(res.data.token)
                const token = res.data.token
                const user = encodeToken.sub

                ctx.commit(types.SET_USER, user)
                ctx.commit(types.SET_TOKEN, token)

                const userService = new UserService
                userService.setToken(token)

                axios.defaults.headers.common["Authorization"] = 'Bearer ' + userService.getToken()

                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const checkLogin = (ctx, form) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.checkLogin, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const loginOtp = (ctx, form) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.loginOtp, form)
            .then(res => {
                const encodeToken = jwtDecode(res.data.token)
                const token = res.data.token
                const user = encodeToken.sub

                ctx.commit(types.SET_USER, user)
                ctx.commit(types.SET_TOKEN, token)

                const userService = new UserService
                userService.setToken(token)

                axios.defaults.headers.common["Authorization"] = 'Bearer ' + userService.getToken()

                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const loginGoogle2fa = (ctx, form) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.loginGoogle2fa, form)
            .then(res => {
                const encodeToken = jwtDecode(res.data.token)
                const token = res.data.token
                const user = encodeToken.sub

                ctx.commit(types.SET_USER, user)
                ctx.commit(types.SET_TOKEN, token)

                const userService = new UserService
                userService.setToken(token)

                axios.defaults.headers.common["Authorization"] = 'Bearer ' + userService.getToken()

                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.user.create, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.user.update.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findById = (ctx, id) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findById.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findMany = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findMany

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findManyCountry = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findManyCountry

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findManyGuest = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findManyGuest

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findUserDetail = (ctx, id) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findUserDetail.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findQuizPayout = (ctx, id) =>{
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findQuizPayout.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const updateQuizPayout = (ctx, { id, form, payoutId }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.user.updateQuizPayout.replace(/__id__/, id).replace(/__payout-id__/, payoutId)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteUser = (ctx, {id}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.delete.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const addCreditUser = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.order.addCreditUser, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const removeCreditUser = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.order.removeCreditUser, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const sendCampaign = (ctx, { id, form }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.user.sendCampaign.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findBySchool = (ctx, { id, params }) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.user.findBySchool.replace(/__id__/, id)
        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const otp = (ctx, form) => {

    return new Promise((resolve, reject) => {
        axios.post(API_URL.otp, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateGoogle2fa = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.updateGoogle2fa.replace(/__id__/, id)
        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getGoogle2fa = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findGoogle2faData.replace(/__id__/, id)
        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findByPartnerAffiliateCode = (ctx, code) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findByPartnerAffiliateCode.replace(/__code__/, code)

        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findUserByAffiliateCode = (ctx, code) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findUserByAffiliateCode.replace(/__code__/, code)

        axios.get(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const deleteSubscriber = (ctx, {id}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.deleteSubscriber.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findUtmList = (ctx, params = {}) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.user.findUtmList

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const findPartnerList = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findPartnerList

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const addNumberAiQusetion = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.addNumberAiQusetion.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findInactiveUsers = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.findInactiveUsers

        axios.get(url, {params}).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const adminDeleteUser = (ctx, {id}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.user.adminDeleteUser.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}
